import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <a href="#" className="footer__logo">
            <img src="/images/evolify_logo.png" alt="Evo" className="footer__logo-img" />
            <img src="/images/evolify-welcome-2.png" alt="Evolify" className="footer__logo-wordmark" />
          </a>
          <p className="footer__tagline">
            L'outil éducatif gamifié pour construire l'autonomie des enfants, sans cris et sans surstimulation numérique.
          </p>
          <p className="footer__made">
            Fait avec ❤️ par des parents, pour des parents.
          </p>
        </div>

        <div className="footer__links">
          <div className="footer__col">
            <h4>Application</h4>
            <ul>
              <li><a href="#fonctionnement">Comment ça marche</a></li>
              <li><a href="#fonctionnalites">Fonctionnalités</a></li>
              <li><a href="#philosophie">Notre approche</a></li>
              <li><a href="#contact">Rejoindre la bêta</a></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4>Concept</h4>
            <ul>
              <li><a href="#philosophie">Les 3 piliers</a></li>
              <li><a href="#philosophie">Gamification douce</a></li>
              <li><a href="#philosophie">Mode Autonomie</a></li>
              <li><a href="#philosophie">Petit mot d'Evo</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© 2025 Evolify. Tous droits réservés.</p>
          <p className="footer__bottom-note">
            Construit avec bienveillance · Version bêta
          </p>
        </div>
      </div>
    </footer>
  );
}
